import type { IconData } from '@stacksjs/iconify-core'

export const intersexSymbolSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M40.497.512a1.934 1.934 0 0 1 1.991 1.992c-.068 2.349-.28 4.61-.483 6.383c-.079.685-.478 1.226-1.039 1.46c-.566.238-1.23.134-1.76-.331a55 55 0 0 1-1.404-1.283l-.024.024l-5.499 5.5a14.43 14.43 0 0 1 2.232 7.732c0 7.156-5.184 13.1-12 14.285v2.215h1.5a2.5 2.5 0 1 1 0 5h-1.5v1.5a2.5 2.5 0 1 1-5 0v-1.5h-1.5a2.5 2.5 0 0 1 0-5h1.5v-2.214c-6.817-1.185-12-7.13-12-14.286c0-8.008 6.492-14.5 14.5-14.5c3.358 0 6.449 1.142 8.907 3.058l5.325-5.326l.012-.011a54 54 0 0 1-1.305-1.411c-.459-.517-.572-1.168-.347-1.73c.223-.557.75-.957 1.424-1.043a68 68 0 0 1 6.47-.514M10.51 21.989a9.5 9.5 0 1 1 19 0a9.5 9.5 0 0 1-19 0\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default intersexSymbolSolid
